var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnited({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.5 47.5",
    id: "united",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38h38V0H0v38Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#269",
    d: "M1.25 12.575v4.926h7.035L1.25 12.575ZM7.08 40H17.5v-7.296L7.08 40ZM30 32.705V40h10.419L30 32.705ZM1.25 30v4.926L8.287 30H1.25ZM40.421 7.5H30v7.296L40.421 7.5ZM46.25 34.928V30h-7.039l7.039 4.928ZM46.25 17.5v-4.926L39.214 17.5h7.036ZM17.5 7.5H7.08l10.42 7.296V7.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dd2e44",
    d: "m26.14 14 9.712-6.801c.471.48.808 1.082.99 1.749L29.627 14H26.14ZM14 14h-2.141L2.148 7.2a3.991 3.991 0 0 1 1.938-1.085L14 13.057V14ZM24 24h2.141l9.711 6.8a3.993 3.993 0 0 1-1.937 1.085L24 24.943V24ZM11.859 24l-9.711 6.8a3.994 3.994 0 0 1-.991-1.749L8.372 24h3.487Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M37 16H22V6h2v5.836L32.335 6H33a3.99 3.99 0 0 1 2.852 1.199L26.14 14h3.487l7.215-5.052c.093.337.158.686.158 1.052v.058L31.369 14H37v2ZM1 16v-2h5.63L1 10.059V10c0-1.091.439-2.078 1.148-2.8l9.711 6.8H14v-.943L4.086 6.115C4.38 6.046 4.684 6 5 6h.664L14 11.837V6h2v10H1ZM37 28a3.983 3.983 0 0 1-1.148 2.8L26.141 24H24v.943l9.915 6.942A4.001 4.001 0 0 1 33 32h-.663L24 26.163V32h-2V22h15v2h-5.629L37 27.941V28ZM14 32v-5.837L5.664 32H5a3.985 3.985 0 0 1-2.852-1.2l9.711-6.8H8.372l-7.215 5.051A3.968 3.968 0 0 1 1 28v-.059L6.628 24H1v-2h15v10h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd2e44",
    d: "M22 22v10h-6V22H1v-6h15V6h6v10h15v6H22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnited);
export default __webpack_public_path__ + "static/media/united.573f47421a93c0f34caa300937e13ef9.svg";
export { ForwardRef as ReactComponent };